import { apiClient } from '../../client'
import { createDiaryFunctions } from '../factory'
import {
    EvidenceDiary,
    EvidenceDiaryDeleteResponse,
    EvidenceDiaryDetailResponse,
    EvidenceDiaryListCriteria,
    EvidenceDiaryListResponse,
    EvidenceDiaryLogResponse,
    EvidenceDiaryUpdatePayload,
} from './types'

const evidenceDiaryFunctions = createDiaryFunctions<
    EvidenceDiary,
    EvidenceDiaryUpdatePayload,
    EvidenceDiaryListResponse,
    EvidenceDiaryDetailResponse,
    EvidenceDiaryDeleteResponse,
    EvidenceDiaryListCriteria
>('v1/evidence-diary')

export const getEvidenceDiaries = evidenceDiaryFunctions.getDiaries
export const getEvidenceDiary = evidenceDiaryFunctions.getDiary
export const updateEvidenceDiary = evidenceDiaryFunctions.updateDiary
export const deleteEvidenceDiary = evidenceDiaryFunctions.deleteDiary
export const downloadEvidenceDiaryPdf = evidenceDiaryFunctions.downloadDiaryPdf

export const getEvidenceDiaryLog = async (id: number | string): Promise<EvidenceDiaryLogResponse> => {
    const response = await apiClient(`v1/evidence-diary/${id}/log`)
    return response.data
}
